export default __webpack_public_path__ + "static/media/Child-documentation.1046cf77.md";